import { motion } from "framer-motion";
import { PROFILE } from "../lib/data";

export const Footer = () => (
  <footer className="border-t border-[#262626] bg-[#0A0A0A]" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10">
      <motion.a
        href={`tel:${PROFILE.phoneTel}`}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="block font-serif font-light text-[15vw] lg:text-[12vw] leading-[0.85] tracking-tight text-[#F7F5F2] hover:text-[#C8A24B] transition-colors duration-500"
        data-testid="footer-cta"
      >
        Let&rsquo;s talk.
      </motion.a>

      <div className="mt-16 grid md:grid-cols-4 gap-10 border-t border-[#262626] pt-12">
        <div className="md:col-span-2">
          <p className="overline">{PROFILE.firmTag}</p>
          <p className="font-serif text-2xl text-[#F7F5F2] mt-2">{PROFILE.firm}</p>
          <p className="text-[#8C8C8C] mt-3 max-w-sm leading-relaxed">
            A dedicated criminal law firm before the Punjab &amp; Haryana High Court — bail, quashing, appeals, NDPS &amp; criminal family matters.
          </p>
        </div>
        <div>
          <p className="overline">Chamber</p>
          <p className="text-[#8C8C8C] text-sm mt-4 leading-relaxed">{PROFILE.address.line1}</p>
          <p className="text-[#8C8C8C] text-sm leading-relaxed">{PROFILE.address.line2}</p>
          <p className="text-[#8C8C8C] text-sm leading-relaxed">{PROFILE.address.line3}</p>
        </div>
        <div>
          <p className="overline">Reach</p>
          <a href={`tel:${PROFILE.phoneTel}`} className="block text-[#F7F5F2] text-sm mt-4 hover:text-[#C8A24B] transition-colors">{PROFILE.phoneDisplay}</a>
          <a href={`mailto:${PROFILE.email}`} className="block text-[#8C8C8C] text-sm mt-2 hover:text-[#C8A24B] transition-colors break-all">{PROFILE.email}</a>
          <a href={PROFILE.whatsapp} target="_blank" rel="noopener noreferrer" className="block text-[#8C8C8C] text-sm mt-2 hover:text-[#C8A24B] transition-colors">WhatsApp</a>
          <p className="text-[#8C8C8C] text-sm mt-2">{PROFILE.hours}</p>
        </div>
      </div>

      <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-[#262626] pt-8">
        <p className="font-mono text-xs text-[#5c5c5c] uppercase tracking-wider">© {new Date().getFullYear()} {PROFILE.firm}. All rights reserved.</p>
        <p className="font-mono text-xs text-[#5c5c5c]">Advocate {PROFILE.name} · Chandigarh</p>
      </div>
    </div>
  </footer>
);
